export default __webpack_public_path__ + "static/media/Nuffield-gym-offer_955x875.212980e9.jpg";